import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { currencies } from '../currencyExchangeRule';
export const PAYMENT_TYPES = [{
  value: 'DIR',
  label: 'Pagamento direto'
}, {
  value: 'DIR_IATA',
  label: 'Pagamento direto IATA'
}, {
  value: 'OFF_CC',
  label: 'Cartão de crédito Offline'
}, {
  value: 'ON_CC',
  label: 'Cartão de crédito Online'
}, {
  value: 'OFF_ANT',
  label: 'Antecipado'
}, {
  value: 'OFF_FAT',
  label: 'Faturado'
}, {
  value: 'ON_PIX',
  label: 'Pix'
}];
export default fillCrudMetadataGaps({
  label: 'Configuração de Saldo',
  labelPlural: 'Configurações de Saldo',
  name: 'LedgerConfiguration',
  namePlural: 'LedgerConfigurations',
  custom_withAudit: true,
  custom_blockRecord: true,
  authorization: authorization('consultant', 'admin'),
  deletable: false,
  dynamoDB: {
    tableName: 'SpearLedgerConfiguration'
  },
  i18n_enabled: true,
  columns: ['id', 'name', 'enabled', 'clientType', 'description', 'unitText'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Nome da configuração',
    required: true,
    i18n_enabled: true
  }, {
    name: 'description',
    label: 'Descrição longa',
    required: true,
    i18n_enabled: true
  }, {
    name: 'walletType',
    label: 'Tipo de carteira',
    type: 'text',
    options: [{
      value: 'CASHBACK',
      label: 'Cashback'
    }, {
      value: 'POINTS',
      label: 'Pontos'
    }]
  }, {
    name: 'currency',
    label: 'Moeda',
    type: 'text',
    inputType: 'select',
    options: currencies,
    conditionalRequired: e => e.walletType === 'CASHBACK',
    renderForm: e => e.walletType === 'CASHBACK'
  }, {
    name: 'unitText',
    label: 'Unidade',
    hint: 'Unidade do saldo.',
    conditionalRequired: e => e.walletType !== 'CASHBACK',
    renderForm: e => e.walletType !== 'CASHBACK'
  }, {
    name: 'decimalPlaces',
    label: 'Quantidade de casas decimais',
    required: true,
    updatable: false,
    insertable: true,
    type: 'int',
    min: 0,
    step: 1
  }, {
    name: 'initialBalanceInt',
    label: 'Saldo Inicial',
    required: true,
    type: 'int',
    hint: 'Valor inicial que vai ser criado a carteira.'
  }, {
    name: 'loyaltyRewardExpiration',
    label: 'Validade do Benefício',
    type: 'int',
    withNullSelector: true,
    nullSelectorDeselectValue: 1,
    nullSelectorLabel: 'Não expira',
    hint: 'Tempo de validade do cashback/ponto a partir da sua aquisição',
    onEntityChange: (oldEntity, newEntity) => {
      if (newEntity.loyaltyRewardExpiration == null !== (oldEntity.loyaltyRewardExpiration == null)) {
        if (newEntity.loyaltyRewardExpiration == null) {
          return {
            ...newEntity,
            loyaltyRewardExpirationType: null
          };
        } else {
          return {
            ...newEntity,
            loyaltyRewardExpirationType: 'YEARS'
          };
        }
      }
      return newEntity;
    }
  }, {
    name: 'loyaltyRewardExpirationType',
    label: 'Validade do Benefício (unidade de tempo)',
    hint: 'Tempo de validade do cashback/ponto a partir da sua aquisição',
    conditionalRequired: e => e.loyaltyRewardExpiration != null,
    renderForm: function (i) {
      return i.loyaltyRewardExpiration != null ? this.render && this.render(i) : false;
    },
    type: 'text',
    options: [process.env.DEV_OR_HOMOLOG_OR_PROD == 'dev' ? {
      label: 'Minutos',
      value: 'MINUTES'
    } : null, process.env.DEV_OR_HOMOLOG_OR_PROD == 'dev' ? {
      label: 'Horas',
      value: 'HOURS'
    } : null, {
      label: 'Dias',
      value: 'DAYS'
    }, {
      label: 'Meses',
      value: 'MONTHS'
    }, {
      label: 'Anos',
      value: 'YEARS'
    }].filter(Boolean)
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyEnabled',
    label: 'Módulo de Fidelidade - Níveis de fidelidade',
    default: false,
    type: 'boolean',
    hint: 'Habilita a configuração de níveis de fidelidade (tiers)'
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyInitialTier',
    label: 'Nível Inicial de Fidelidade',
    type: 'text',
    hint: 'Valor inicial que vai ser criado a carteira.',
    conditionalRequired: e => e.loyaltyEnabled,
    renderForm: function (i) {
      return i.loyaltyEnabled ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyTiers',
    label: 'Níveis de Fidelidade',
    type: 'objectarray',
    conditionalRequired: e => e.loyaltyEnabled,
    renderForm: function (i) {
      return i.loyaltyEnabled ? this.render && this.render(i) : false;
    },
    graphQLType: '[NestedLoyaltyTier]',
    graphQLInputType: '[NestedNestedLoyaltyTierInput]',
    i18n_enabled: true,
    fields: [{
      name: 'name',
      label: 'Nome',
      type: 'text',
      required: true,
      i18n_enabled: true
    }, {
      name: 'lowerLimit',
      label: 'Limite Inferior',
      type: 'int',
      required: true
    }, {
      name: 'upperLimit',
      label: 'Limite Superior',
      type: 'int',
      required: true
    }, {
      name: 'description',
      label: 'Descrição',
      type: 'text',
      inputType: 'wysiwyg',
      showInModal: true,
      i18n_enabled: true
    }]
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyTierExpirationValue',
    hint: 'Tempo em que o usuário perderá o nível a partir da sua aquisição. Ao fim desse período, o novo nível da pessoa será recalculado a partir dos pontos válidos - e nova validade será calculada.',
    label: 'Validade do Nível',
    type: 'int',
    withNullSelector: true,
    nullSelectorLabel: 'Não expira',
    nullSelectorDeselectValue: 1,
    renderForm: function (i) {
      return i.loyaltyEnabled ? this.render && this.render(i) : false;
    },
    onEntityChange: (oldEntity, newEntity) => {
      if (newEntity.loyaltyTierExpirationValue == null !== (oldEntity.loyaltyTierExpirationValue == null)) {
        if (newEntity.loyaltyTierExpirationValue == null) {
          return {
            ...newEntity,
            loyaltyTierExpirationType: null
          };
        } else {
          return {
            ...newEntity,
            loyaltyTierExpirationType: 'YEARS'
          };
        }
      }
      return newEntity;
    }
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyTierExpirationType',
    label: 'Validade do Nível (Unidade de tempo)',
    hint: 'Tempo em que o usuário perderá o nível a partir da sua aquisição. Ao fim desse período, o novo nível da pessoa será recalculado a partir dos pontos válidos - e nova validade será calculada.',
    type: 'text',
    conditionalRequired: i => i.loyaltyEnabled && i.loyaltyTierExpirationValue != null,
    renderForm: function (i) {
      return i.loyaltyEnabled && i.loyaltyTierExpirationValue != null ? this.render && this.render(i) : false;
    },
    options: [process.env.DEV_OR_HOMOLOG_OR_PROD == 'dev' ? {
      label: 'Minutos',
      value: 'MINUTES'
    } : null, process.env.DEV_OR_HOMOLOG_OR_PROD == 'dev' ? {
      label: 'Horas',
      value: 'HOURS'
    } : null, {
      label: 'Dias',
      value: 'DAYS'
    }, {
      label: 'Meses',
      value: 'MONTHS'
    }, {
      label: 'Anos',
      value: 'YEARS'
    }].filter(Boolean)
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyOptInRequired',
    label: 'Opt-in',
    type: 'boolean',
    hint: 'Se ativado, no checkout aparecerá a opção para pessoa aceitar os termos e condições para poder se cadastrar no programa de fidelidade.'
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyOptInMessage',
    label: 'Mensagem de Opt-in',
    type: 'text',
    inputType: 'wysiwyg',
    hint: 'Mensagem que aparecerá no checkout para pessoa aceitar os termos e condições para poder se cadastrar no programa de fidelidade.',
    i18n_enabled: true
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyOptInMemberMessage',
    label: 'Mensagem de Opt-in para membros',
    type: 'text',
    inputType: 'wysiwyg',
    hint: 'Mensagem que aparecerá no checkout para pessoa que já faz parte do programa de fidelidade.',
    i18n_enabled: true
  }, {
    custom_groupName: 'Fidelidade',
    name: 'loyaltyTermFiles',
    label: 'Termos, políticas, regulamentos',
    type: 'objectarray',
    graphQLType: '[NestedLoyaltyTermsFile]',
    graphQLInputType: '[NestedLoyaltyTermsFileInput]',
    hint: 'Links/arquivos que serão colocados na tela de registro de pessoas e checkout (se opt-in ativado) para aceitar os termos e condições para poder se cadastrar no programa de fidelidade.',
    fields: [{
      name: 'name',
      label: 'Nome',
      hint: 'Termos, condições gerais, regulamento, política de privacidade, etc',
      required: true,
      type: 'text'
    }, {
      name: 'file',
      label: 'Arquivo (PDF)',
      required: false,
      type: 'text',
      inputType: 'inputPublicFile',
      fileType: 'pdf',
      custom_gerarPrefix: i => {
        return 'loyalty/' + i.id + '/terms/';
      }
    }, {
      name: 'url',
      label: 'Link',
      hint: '(ignorado se existir arquivo)',
      required: false,
      type: 'text',
      fileType: 'pdf',
      custom_gerarPrefix: i => {
        return 'loyalty/' + i.id + '/terms/';
      }
    }],
    renderForm: function (i) {
      return i.loyaltyEnabled ? this.render && this.render(i) : false;
    }
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: true,
    required: true,
    type: 'boolean'
  }, {
    name: 'clientType',
    label: 'Tipo de cliente',
    required: true,
    updatable: false,
    type: 'text',
    options: [{
      label: 'Pessoa física (cliente b2c)',
      value: 'PERSON'
    }, {
      label: 'Pessoa jurídica (cliente b2b)',
      value: 'CLIENT'
    }]
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});